module.exports = __webpack_public_path__ + "static/linkedin-icon-6c544b944f3446672a267908351c21bc.png";